import EventPreviewView from './event_preview_view';

const EventPreview = EventPreviewView;
export default EventPreview;
